export default "__VITE_ASSET__CTRXz4yC__"